<template>
  <div class="parogram-index">
    <Header/>
    <Banner/>
    <div style="width: 100%;background-color: #f4f4f4;">
        <RecentMatch/>
    </div>
    <PlayerRanking/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import Banner from './components/Banner'
import RecentMatch from './components/RecentMatch'
import PlayerRanking from './components/PlayerRanking'
import Footer from '../layout/Footer'
// import Footer from './components/Footer'
export default {
  components: {
    Header,
    Banner,
    RecentMatch,
    PlayerRanking,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.parogram-index{
    background-color: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ProgramIndex.vue